import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Row, Col, Select, Popconfirm, Button, Alert, Modal } from 'antd';

const AddForm = ({ visible, error, submitting, handleSubmitForm, handleCloseForm }) => {
  const [form] = Form.useForm();
  const [wordCounter, setWordCounter] = useState(0);

  const announcementTypes = [
    { id: 1, value: 'Genel Duyuru' },
    { id: 2, value: 'Yasal Uyarı' },
    { id: 3, value: 'Tebrik & Kutlama' },
    { id: 4, value: 'Kampanya' },
  ];

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      handleSubmitForm(values);
    } catch (err) {
      console.error('Validation Failed:', err);
    }
  };

  const wordCount = (e) => {
    setWordCounter(e.target.value.length);
  };

  return (
    <Modal
      title="Yeni Duyuru"
      open={visible}
      footer={false}
      okText="Duyuruyu Yayınla"
      cancelText="Vazgeç"
      width="600px"
      destroyOnClose
      onCancel={handleCloseForm}
    >
      <Form form={form} onFinish={handleSubmit} layout="vertical">
        {error && (
          <Form.Item>
            <Alert message={error} type="error" showIcon />
          </Form.Item>
        )}
        <Row>
          <Col span={24}>
            <Form.Item
              name="title"
              label="Duyuru Başlığı"
              rules={[{ required: true, message: 'Zorunlu Alan' }]}
            >
              <Input className="input__default" placeholder="Başlık" />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item name="type" label="Duyuru Tipi" initialValue={announcementTypes[0].value}>
              <Select style={{ width: '100%' }}>
                {announcementTypes.map((t) => (
                  <Select.Option key={t.value} value={t.value}>
                    {t.value}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              name="text"
              label="Duyuru İçeriği"
              rules={[{ required: true, message: 'Zorunlu Alan' }]}
            >
              <Input.TextArea
                maxLength={1000}
                rows={4}
                onChange={wordCount}
                className="input__default"
                placeholder="İçerik"
              />
            </Form.Item>
            <div style={{ textAlign: 'right' }}>{wordCounter}/1000</div>
            <br />
          </Col>

          <Col span={24}>
            <Form.Item className="text-align-right">
              <Button
                className="button button__outline mr-3"
                type="ghost"
                htmlType="button"
                disabled={submitting}
                onClick={handleCloseForm}
              >
                Vazgeç
              </Button>

              <Popconfirm
                title="Duyuruyu yayınlamak istediğinizden emin misiniz?"
                okText="Evet"
                cancelText="Hayır"
                onConfirm={handleSubmit}
                placement="topRight"
              >
                <Button
                  className="button button__fill"
                  type="primary"
                  disabled={submitting}
                  loading={submitting}
                >
                  Yayınla
                </Button>
              </Popconfirm>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

AddForm.propTypes = {
  visible: PropTypes.bool.isRequired,
  error: PropTypes.string,
  submitting: PropTypes.bool.isRequired,
  handleSubmitForm: PropTypes.func.isRequired,
  handleCloseForm: PropTypes.func.isRequired,
};

AddForm.defaultProps = {
  error: null,
};

export default AddForm;
